import { Store } from "@tanstack/react-store";

// 定义全局状态类型
type ModalState = {
	depositModalOpen: boolean;
	inviteModalOpen: boolean;
	isRainbowModalOpen: boolean;
	announcementModalOpen: boolean;
	ppModalOpen: boolean;
	adultModalOpen: boolean;
};

interface ModalStoreActions {
	setDepositModalOpen: (open: boolean) => void;
	setInviteModalOpen: (open: boolean) => void;
	setRainbowModalOpen: (open: boolean) => void;
	setAnnouncementModalOpen: (open: boolean) => void;
	setPPModalOpen: (open: boolean) => void;
	setAdultModalOpen: (open: boolean) => void;
}

class ModalStoreClass extends Store<ModalState> implements ModalStoreActions {
	private updateState(
		key: keyof ModalState,
		value: ModalState[keyof ModalState],
	) {
		this.setState((state) => ({
			...state,
			[key]: value,
		}));
	}

	setDepositModalOpen(open: boolean) {
		this.updateState("depositModalOpen", open);
	}

	setInviteModalOpen(open: boolean) {
		this.updateState("inviteModalOpen", open);
	}

	setRainbowModalOpen(open: boolean) {
		this.updateState("isRainbowModalOpen", open);
	}

	setAnnouncementModalOpen(open: boolean) {
		this.updateState("announcementModalOpen", open);
	}

	setPPModalOpen(open: boolean) {
		this.updateState("ppModalOpen", open);
	}

	setAdultModalOpen(open: boolean) {
		this.updateState("adultModalOpen", open);
	}
}

// Init global store
export const modalStore = new ModalStoreClass({
	depositModalOpen: false,
	inviteModalOpen: false,
	isRainbowModalOpen: false,
	announcementModalOpen: false,
	ppModalOpen: false,
	adultModalOpen: false,
});
